export const SEO_STORAGE_KEY = "adminSeoSettings";

export const normalizePath = (path) => {
  let normalized = String(path || "").trim();
  if (normalized === "") return "/";
  try {
    const url = new URL(normalized, "http://example.com");
    normalized = url.pathname;
  } catch {
    // if it's not a valid URL, use the raw path
  }
  normalized = normalized.replace(/\/+$|^\s+|\s+$/g, "");
  if (normalized === "") normalized = "/";
  if (!normalized.startsWith("/")) normalized = `/${normalized}`;
  return normalized.toLowerCase();
};

export const pathMatchesPattern = (patternPath, currentPath) => {
  const patternSegments = normalizePath(patternPath).split("/").filter(Boolean);
  const currentSegments = normalizePath(currentPath).split("/").filter(Boolean);

  if (patternSegments.length !== currentSegments.length) {
    return false;
  }

  return patternSegments.every((segment, index) => {
    if (segment === "*") return true;
    if (segment.startsWith(":")) return true;
    return segment === currentSegments[index];
  });
};

export const SEO_PAGES = [
  { label: "Home", path: "/" },
  { label: "About Vikash", path: "/about-vikash" },
  { label: "Vision & Mission", path: "/vision-mission" },
  { label: "Our Partners", path: "/our-partners" },
  { label: "Our Team", path: "/our-team" },
  { label: "Sustainable Livelihoods", path: "/sustainable-livelihoods" },
  { label: "Agriculture Livelihood", path: "/agriculture-livelihood" },
  { label: "Non Farm Based Livelihood", path: "/non-farm-based-livelihood" },
  { label: "Health", path: "/health" },
  { label: "Quality Education", path: "/quality-education" },
  { label: "Non Formal Education", path: "/non-formal-education" },
  { label: "Creche Program", path: "/creche-program" },
  { label: "Child Labour Prevention", path: "/child-labour-prevention" },
  { label: "Caring For Tribal Children", path: "/caring-for-tribal-children" },
  { label: "Inclusive Education", path: "/inclusive-education" },
  { label: "Children Parliament", path: "/children-parliament" },
  { label: "Advocacy & Networking", path: "/advocacy-networking" },
  { label: "Special Centers", path: "/special-centers" },
  { label: "Good Governance", path: "/good-governance" },
  { label: "Rural Governance", path: "/rural-governance" },
  { label: "Urban Governance", path: "/urban-governance" },
  { label: "Opportunities For The Disabled", path: "/opportunities-for-the-disabled" },
  { label: "Health (Disabled Programs)", path: "/health1" },
  { label: "Education & Behavior Development", path: "/education-and-behavior-development" },
  { label: "Economic Development", path: "/economic-development" },
  { label: "Social Development", path: "/social-development" },
  { label: "Good Habitat", path: "/good-habitat" },
  { label: "Housing", path: "/housing" },
  { label: "Forestry", path: "/forestry" },
  { label: "Renewable Energy", path: "/renewable-energy" },
  { label: "Water", path: "/water" },
  { label: "Sanitation", path: "/sanitation" },
  { label: "Solid Waste Management", path: "/solid-waste-management" },
  { label: "Bio Medical Waste Management", path: "/bio-medical-waste-management" },
  { label: "News", path: "/news" },
  { label: "Photo Gallery", path: "/photo-gallery" },
  { label: "Video Gallery", path: "/video-gallery" },
  { label: "Research Publications", path: "/research-publications" },
  { label: "Case Studies", path: "/case-studies" },
  { label: "Annual Reports", path: "/annual-reports" },
  { label: "Events Reports", path: "/events-reports" },
  { label: "Volunteers", path: "/volunteer" },
  { label: "Interns", path: "/interns" },
  { label: "Career", path: "/career" },
  { label: "Blog", path: "/blog" },
  { label: "Contact Us", path: "/contact-us" },
  { label: "Internship", path: "/internship" },
];

export const createDefaultSeoState = () => ({
  selectedPage: "/",
  pages: {},
});

export const loadSeoSettings = () => {
  try {
    const raw = localStorage.getItem(SEO_STORAGE_KEY);
    if (!raw) return createDefaultSeoState();
    const parsed = JSON.parse(raw);
    if (parsed && typeof parsed === "object") {
      if (parsed.pages && typeof parsed.pages === "object") {
        const normalizedPages = Object.keys(parsed.pages).reduce((acc, key) => {
          acc[normalizePath(key)] = parsed.pages[key];
          return acc;
        }, {});
        return {
          selectedPage: normalizePath(parsed.selectedPage || "/"),
          pages: normalizedPages,
        };
      }
      return {
        selectedPage: "/",
        pages: {
          "/": {
            page_title: parsed.page_title || "",
            meta_title: parsed.meta_title || "",
            meta_description: parsed.meta_description || "",
            meta_keywords: parsed.meta_keywords || "",
          },
        },
      };
    }
  } catch (error) {
    console.error("Failed to load SEO settings", error);
  }
  return createDefaultSeoState();
};

export const saveSeoSettings = (settings) => {
  try {
    const normalized = {
      ...settings,
      selectedPage: normalizePath(settings.selectedPage),
      pages: Object.keys(settings.pages || {}).reduce((acc, key) => {
        acc[normalizePath(key)] = settings.pages[key];
        return acc;
      }, {}),
    };
    localStorage.setItem(SEO_STORAGE_KEY, JSON.stringify(normalized));
  } catch (error) {
    console.error("Failed to save SEO settings", error);
  }
};

export const getSeoForPath = (path) => {
  const settings = loadSeoSettings();
  const normalizedPath = normalizePath(path);
  const directMatch = settings.pages[normalizedPath];
  if (directMatch) return directMatch;

  const patternMatchEntry = Object.entries(settings.pages).find(([key]) =>
    key.includes(":") && pathMatchesPattern(key, normalizedPath)
  );
  return patternMatchEntry ? patternMatchEntry[1] : null;
};
